import { render, staticRenderFns } from "./NiaoSuan.vue?vue&type=template&id=dc21e3c8&scoped=true&"
import script from "./NiaoSuan.vue?vue&type=script&lang=js&"
export * from "./NiaoSuan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc21e3c8",
  null
  
)

export default component.exports